import styles from './FJMoreTool.module.less';
import FJAppConstant from '../../../../../constants/FJAppConstant.js';
import { RELEASE } from '../../../../../constants/FJEvnConstant.js';
import FJLocalStore from '../../../../../store/FJLocalStore.js';
import { AI_GENERATOR_VIDEO_TAB_TYPE } from '../../../../../config/dataConfig/FJAIVideoGeneratorData.js';
import FJFlexClipIcon from '../../../../../assets/svg/community/FlexClip.svg?react';
import FJTextToImageIcon from '../../../../../assets/svg/community/text-to-image.svg?react';
import FJImageRemoveBgIcon from '../../../../../assets/svg/community/img-remove-bg.svg?react';
import FJPhotoEditorIcon from '../../../../../assets/svg/community/photo-editor.svg?react';
import FJSfxIcon from '../../../../../assets/svg/community/sfx.svg?react';
import FJImgToImgIcon from '../../../../../assets/svg/community/img-to-img.svg?react';
import FJImageToVideoIcon from '../../../../../assets/svg/community/img-to-video.svg?react';
import FJTextToVideoIcon from '../../../../../assets/svg/community/text-to-video.svg?react';
import FJObjectRemoveIcon from '../../../../../assets/svg/community/object-remove.svg?react';
import FJVideoRemoveBgIcon from '../../../../../assets/svg/community/video-remove-bg.svg?react';
import FJVideoEffectIcon from '../../../../../assets/svg/community/video-effect.svg?react';
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import FJUtil from '../../../../../util/FJUtil.js';
import FJCommunityUtil from '../../../../../util/FJCommunityUtil.js';

const environment = import.meta.env.MODE;
const isRelease = environment !== RELEASE;

const moreToolInfo = {};

moreToolInfo[FJAppConstant.TEXT_TO_IMAGE] = [
    {
        title: 'flexclip-video-editor',
        icon: FJFlexClipIcon,
        href: '/editor/app?ratio=landscape',
    },
    {
        title: 'ai-image-to-video',
        icon: FJImageToVideoIcon,
        href: isRelease ? '/apply/video-generator/image-to-video' : '/ai/video-generator/image-to-video',
    },
    {
        title: 'ai-photo-editor',
        icon: FJPhotoEditorIcon,
        href: isRelease ? '/apply/photo-editor/' : '/ai/photo-editor/',
    },
    {
        title: 'ai-image-to-image',
        icon: FJImgToImgIcon,
        href: isRelease ? '/apply/image-to-image/' : '/ai/image-to-image/',
    },
    {
        title: 'ai-image-bg-remover',
        icon: FJImageRemoveBgIcon,
        href: isRelease ? '/apply/image-background-remover/' : '/ai/image-background-remover/',
    },
    {
        title: 'ai-object-eraser',
        icon: FJObjectRemoveIcon,
        href: isRelease ? '/apply/object-remover/' : '/ai/object-remover/',
    },
];

moreToolInfo[FJAppConstant.IMAGE_TO_IMAGE] = [
    {
        title: 'flexclip-video-editor',
        icon: FJFlexClipIcon,
        href: '/editor/app?ratio=landscape',
    },
    {
        title: 'ai-image-to-video',
        icon: FJImageToVideoIcon,
        href: isRelease ? '/apply/video-generator/image-to-video' : '/ai/video-generator/image-to-video',
    },
    {
        title: 'ai-photo-editor',
        icon: FJPhotoEditorIcon,
        href: isRelease ? '/apply/photo-editor/' : '/ai/photo-editor/',
    },
    {
        title: 'ai-image-bg-remover',
        icon: FJImageRemoveBgIcon,
        href: isRelease ? '/apply/image-background-remover/' : '/ai/image-background-remover/',
    },
    {
        title: 'ai-object-eraser',
        icon: FJObjectRemoveIcon,
        href: isRelease ? '/apply/object-remover/' : '/ai/object-remover/',
    },
    {
        title: 'ai-text-to-image',
        icon: FJTextToImageIcon,
        href: isRelease ? '/apply/text-to-image/' : '/ai/text-to-image/',
    },
];

moreToolInfo[FJAppConstant.AI_PHOTO_EDITOR] = [
    {
        title: 'flexclip-video-editor',
        icon: FJFlexClipIcon,
        href: '/editor/app?ratio=landscape',
    },
    {
        title: 'ai-image-to-video',
        icon: FJImageToVideoIcon,
        href: isRelease ? '/apply/video-generator/image-to-video' : '/ai/video-generator/image-to-video',
    },
    {
        title: 'ai-image-to-image',
        icon: FJImgToImgIcon,
        href: isRelease ? '/apply/image-to-image/' : '/ai/image-to-image/',
    },
    {
        title: 'ai-image-bg-remover',
        icon: FJImageRemoveBgIcon,
        href: isRelease ? '/apply/image-background-remover/' : '/ai/image-background-remover/',
    },
    {
        title: 'ai-object-eraser',
        icon: FJObjectRemoveIcon,
        href: isRelease ? '/apply/object-remover/' : '/ai/object-remover/',
    },
    {
        title: 'ai-text-to-image',
        icon: FJTextToImageIcon,
        href: isRelease ? '/apply/text-to-image/' : '/ai/text-to-image/',
    },
];

moreToolInfo[FJAppConstant.TEXT_TO_VIDEO] = [
    {
        title: 'flexclip-video-editor',
        icon: FJFlexClipIcon,
        href: '/editor/app?ratio=landscape',
    },
    {
        title: 'ai-video-bg-remover',
        icon: FJVideoRemoveBgIcon,
        href: isRelease ? '/apply/video-background-remover/' : '/ai/video-background-remover/',
    },
    {
        title: 'ai-image-to-video',
        icon: FJImageToVideoIcon,
        href: isRelease ? '/apply/video-generator/image-to-video' : '/ai/video-generator/image-to-video',
    },
    {
        title: AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO,
        icon: FJVideoEffectIcon,
        href: isRelease ? '/apply/video-generator/video-effect/' : '/ai/video-generator/video-effect/',
    },
    {
        title: 'ai-photo-editor',
        icon: FJPhotoEditorIcon,
        href: isRelease ? '/apply/photo-editor/' : '/ai/photo-editor/',
    },
    {
        title: 'ai-video-dub',
        icon: FJSfxIcon,
        href: isRelease ? '/apply/video-to-ai-sfx-generator/' : '/ai/video-to-ai-sfx-generator/',
    },
];

moreToolInfo[FJAppConstant.IMAGE_TO_VIDEO] = [
    {
        title: 'flexclip-video-editor',
        icon: FJFlexClipIcon,
        href: '/editor/app?ratio=landscape',
    },
    {
        title: 'ai-video-bg-remover',
        icon: FJVideoRemoveBgIcon,
        href: isRelease ? '/apply/video-background-remover/' : '/ai/video-background-remover/',
    },
    {
        title: 'ai-text-to-video',
        icon: FJTextToVideoIcon,
        href: isRelease ? '/apply/video-generator/text-to-video' : '/ai/video-generator/text-to-video',
    },
    {
        title: AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO,
        icon: FJVideoEffectIcon,
        href: isRelease ? '/apply/video-generator/video-effect/' : '/ai/video-generator/video-effect/',
    },
    {
        title: 'ai-photo-editor',
        icon: FJPhotoEditorIcon,
        href: isRelease ? '/apply/photo-editor/' : '/ai/photo-editor/',
    },
    {
        title: 'ai-video-dub',
        icon: FJSfxIcon,
        href: isRelease ? '/apply/video-to-ai-sfx-generator/' : '/ai/video-to-ai-sfx-generator/',
    },
];

moreToolInfo[FJAppConstant.AI_VIDEO_EFFECT] = [
    {
        title: 'flexclip-video-editor',
        icon: FJFlexClipIcon,
        href: '/editor/app?ratio=landscape',
    },
    {
        title: 'ai-video-bg-remover',
        icon: FJVideoRemoveBgIcon,
        href: isRelease ? '/apply/video-background-remover/' : '/ai/video-background-remover/',
    },
    {
        title: 'ai-text-to-video',
        icon: FJTextToVideoIcon,
        href: isRelease ? '/apply/video-generator/text-to-video' : '/ai/video-generator/text-to-video',
    },
    {
        title: AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO,
        icon: FJVideoEffectIcon,
        href: isRelease ? '/apply/video-generator/video-effect/' : '/ai/video-generator/video-effect/',
    },
    {
        title: 'ai-photo-editor',
        icon: FJPhotoEditorIcon,
        href: isRelease ? '/apply/photo-editor/' : '/ai/photo-editor/',
    },
    {
        title: 'ai-video-dub',
        icon: FJSfxIcon,
        href: isRelease ? '/apply/video-to-ai-sfx-generator/' : '/ai/video-to-ai-sfx-generator/',
    },
];

const FJMoreTool = props => {
    const { jobType, generationType, workType } = props;
    const { list, originalAppType } = useMemo(() => {
        switch (jobType) {
            case 6:
                return {
                    list: moreToolInfo[FJAppConstant.TEXT_TO_IMAGE],
                    originalAppType: FJAppConstant.TEXT_TO_IMAGE,
                };
            case 3:
                return {
                    list: moreToolInfo[FJAppConstant.IMAGE_TO_IMAGE],
                    originalAppType: FJAppConstant.IMAGE_TO_IMAGE,
                };
            case 36:
                return {
                    list: moreToolInfo[FJAppConstant.AI_PHOTO_EDITOR],
                    originalAppType: FJAppConstant.AI_PHOTO_EDITOR,
                };
            case 28:
                return {
                    list: moreToolInfo[FJAppConstant.AI_VIDEO_EFFECT],
                    originalAppType: FJAppConstant.AI_VIDEO_EFFECT,
                };
            case 14:
                return {
                    list: moreToolInfo[
                        generationType === 'iv' ? FJAppConstant.IMAGE_TO_VIDEO : FJAppConstant.TEXT_TO_VIDEO
                    ],
                    originalAppType: generationType === 'iv' ? 'ai image to video' : 'ai text to video',
                };
            default:
                return { list: [], originalAppType: '' };
        }
    }, [jobType, generationType]);

    const _onClick = info => {
        window.open(info.href, '_blank');

        FJUtil.eaLog('ai preview tools click', {
            tool: info.title.replaceAll('-', ' '),
            'current tools': FJUtil.getToolName(originalAppType),
            'ai page': FJCommunityUtil.getCommunityPageName({ workType }),
        });
    };

    return (
        <div className={styles.box}>
            <div className={styles.title}>{FJLocalStore._('more-tools')}</div>
            <div className={styles.tool_list}>
                {list.map((toolItem, index) => {
                    return (
                        <div
                            className={styles.item}
                            key={index}
                            onClick={() => {
                                _onClick(toolItem);
                            }}
                        >
                            <div className={styles.icon}>
                                <toolItem.icon />
                            </div>
                            <div className={styles.text}>{FJLocalStore._(toolItem.title)}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

FJMoreTool.propTypes = {
    jobType: PropTypes.number,
    generationType: PropTypes.string,
    workType: PropTypes.string,
};
export default FJMoreTool;
